"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Category = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.summary.category.section; });
var Title = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\ttext-align: left;\n\t", ";\n"], ["\n\ttext-align: left;\n\t", ";\n"])), function (props) { return props.theme.summary.category.title; });
var Subtotal = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.summary.category.subtotal; });
var SummaryCategory = /** @class */ (function (_super) {
    __extends(SummaryCategory, _super);
    function SummaryCategory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryCategory.prototype.render = function () {
        if (!this.props.children) {
            return null;
        }
        return (react_1.default.createElement(Category, { className: this.props.className },
            react_1.default.createElement("table", { style: { width: "100%" } },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { colSpan: 100 },
                            react_1.default.createElement(Title, null, this.props.title),
                            react_1.default.createElement(Subtotal, null, this.props.subtotal)))),
                react_1.default.createElement("tbody", null, this.props.children))));
    };
    SummaryCategory.propTypes = {
        title: prop_types_1.default.node.isRequired,
        subtotal: prop_types_1.default.node.isRequired,
        children: prop_types_1.default.node
    };
    SummaryCategory.defaultProps = {
        title: '',
        subtotal: '',
    };
    return SummaryCategory;
}(react_1.Component));
exports.default = styled_components_1.withTheme(SummaryCategory);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SummaryCategory.js.map